<template>
    <div class="w-100 big-container">
        <div v-if="this.conf.tipo_modalita_zone === 'MANUALE'">
            <div class="title">{{this.$t('scegli_citta')}}</div>
            <div class="container">
                <lv1-delivery-manuale
                    :consegne-citta="this.conf.consegne_citta"
                    :address="this.address"
                    @onCityPicked="this.onCityPicked"
                    @onZonePicked="this.onZonePicked"
                />
            </div>
        </div>
        <div v-if="this.conf.tipo_modalita_zone === 'COORDINATE'">
            <div class="title">{{this.$t('inserisci_indirizzo')}}</div>
            <div class="container">
                <lv1-delivery-coordinate
                    :consegne-citta="this.conf.consegne_citta"
                    :address="this.address"
                    @onAddressPicked="this.onAddressPicked"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Lv1DeliveryManuale from "./Lv1DeliveryManuale";
import Lv1DeliveryCoordinate from "./Lv1DeliveryCoordinate";

export default {
    name: "Lv1Delivery",
    components: {Lv1DeliveryCoordinate, Lv1DeliveryManuale},
    props: ['conf', 'address'],
    methods: {
        onCityPicked: function (citta) {
            this.$emit('onIndirizzoManualeCittaPicked', citta);
        },
        onZonePicked: function (zona) {
            this.$emit('onIndirizzoManualeZonaPicked', zona);
        },
        onAddressPicked: function (geocodeResult, formattedAddress, houseNumber) {
            this.$emit('onIndirizzoCoordinatePicked', geocodeResult, formattedAddress, houseNumber);
        }
    }
}
</script>
